var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.75,6.08c.06-1.54.52-2.23,1.91-2.82,2.22-.93,4.44-1.87,6.65-2.83.5-.22.96-.23,1.47-.01,2.26.98,4.53,1.93,6.79,2.89,1.21.51,1.73,1.22,1.68,2.53-.19,4.72-1.76,8.82-5.46,11.93-.78.65-1.69,1.15-2.58,1.66-.76.45-1.56.4-2.35,0-3.94-2-6.29-5.27-7.41-9.47-.34-1.26-.48-2.58-.71-3.87Zm8,5.11c-.59-.63-1.13-1.24-1.71-1.81-.39-.39-.99-.37-1.34-.02-.38.38-.42.92-.02,1.34.8.84,1.63,1.66,2.46,2.47.43.42.95.41,1.38,0,1.64-1.62,3.27-3.26,4.89-4.89.31-.32.42-.7.18-1.12-.33-.61-1.06-.68-1.64-.11-1.24,1.22-2.47,2.46-3.7,3.69-.13.13-.27.25-.5.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.16d226670b9220bd4fd2668d056f349e.svg";
export { ForwardRef as ReactComponent };